import { useState } from "react";
import { Confirm } from "@circle-react/components/shared/uikit/Confirm";
import type { ButtonVariant } from "@circle-react-uikit/Button";

interface UseConfirmModalParams {
  bodyElement?: React.ReactNode;
  buttonLabel?: string;
  description?: string;
  maxIndex?: boolean;
  onConfirm: () => void | Promise<void>;
  sentiment?: ButtonVariant;
  title: string;
}

export const useConfirmModal = ({
  title,
  onConfirm,
  bodyElement = null,
  description = "",
  buttonLabel = "",
  maxIndex = false,
  sentiment = "danger",
}: UseConfirmModalParams) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const onConfirmButtonClick = () => {
    setIsConfirmModalOpen(true);
  };

  const onConfirmModalClose = () => {
    setIsConfirmModalOpen(false);
  };

  const onConfirmModal = () => {
    setIsConfirmModalOpen(false);
    void onConfirm();
  };

  const confirmModal = (
    <Confirm
      show={isConfirmModalOpen}
      onClose={onConfirmModalClose}
      onCancel={onConfirmModalClose}
      onConfirm={onConfirmModal}
      title={title}
      subtitle=""
      description={description}
      bodyElement={bodyElement}
      maxZIndexEnabled={maxIndex}
      buttonLabel={buttonLabel}
      sentiment={sentiment}
    />
  );

  return {
    confirmModal,
    isConfirmModalOpen,
    onConfirmButtonClick,
    onConfirmModalClose,
    onConfirmModal,
  };
};
